module.exports = __webpack_public_path__ + "assets/font/MiSans-Thin-15a32047.woff2";